export default __webpack_public_path__ + "static/media/pen.87854dd4.svg";